var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCB45EB6-EE9F-4B7F-81CA-00821F87BE8E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.0000007,14 C29.5400007,14 30.8000007,15.2599999 30.8000007,16.7999999 L30.8000007,28 C30.8000007,29.5399993 29.5400007,30.7999992 28.0000007,30.7999992 C26.4600007,30.7999992 25.2000008,29.5399993 25.2000008,28 L25.2000008,16.7999999 C25.2000008,15.2599999 26.4600007,14 28.0000007,14 Z M27.972,0 C12.516,0 0,12.544 0,28 C0,43.456 12.516,56 27.972,56 C43.456,56 56,43.456 56,28 C56,12.544 43.456,0 27.972,0 Z M27.9999995,50.3999991 C15.6239997,50.3999991 5.5999999,40.3759993 5.5999999,27.9999995 C5.5999999,15.6239997 15.6239997,5.5999999 27.9999995,5.5999999 C40.3759993,5.5999999 50.3999991,15.6239997 50.3999991,27.9999995 C50.3999991,40.3759993 40.3759993,50.3999991 27.9999995,50.3999991 Z M28.0000007,42.0000014 C26.4536034,42.0000014 25.2000008,40.7463988 25.2000008,39.2000015 C25.2000008,37.6536042 26.4536034,36.4000015 28.0000007,36.4000015 C29.546398,36.4000015 30.8000007,37.6536042 30.8000007,39.2000015 C30.8000007,40.7463988 29.546398,42.0000014 28.0000007,42.0000014 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7_Issue-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comments-Entered",
    transform: "translate(-824.000000, -172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Classify-Asset-Class-Header",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results-Detail-/-Icon-/-Review-Required",
    transform: "translate(824.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Review-required-icon",
    fill: "#F2950D",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewRequired);
export default __webpack_public_path__ + "static/media/review-required.47217bcfb2eec1c54aeb592dfd135b1d.svg";
export { ForwardRef as ReactComponent };